/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const refreshQuantityButtons = function() {
  document.querySelectorAll('.quantity-selector__value').forEach(function(quantityEl) {
    let parentFormElement = quantityEl.parentElement;

    while (!parentFormElement.classList.contains("product-form")) {
      parentFormElement = parentFormElement.parentElement;
    }

    const productEl = document.querySelector("form script[data-product-json]");

    if (!productEl) {
      return;
    }

    const productJSON = JSON.parse(productEl.innerHTML);
    const variantId = parentFormElement.querySelector('option[selected]')?.value || parentFormElement.querySelector("input[name='id']")?.value;
    const decQuantityElements = document.querySelectorAll("[data-action='decrease-picker-quantity']");
    const incQuantityElements = document.querySelectorAll("[data-action='increase-picker-quantity']");
    const variantInventory = JSON.parse(document.querySelector('[data-product-json]').innerHTML).inventories[variantId];

    decQuantityElements.forEach(function(decQuantityElement) {
      if (quantityEl.value > 1) {
        decQuantityElement.style.color = 'var(--heading-color)';
      } else {
        decQuantityElement.style.color = 'rgba(117, 141, 163, 0.6)';
      }
    });
    incQuantityElements.forEach(function(incQuantityElement) {
      if (quantityEl.value == variantInventory.inventory_quantity) {
        incQuantityElement.style.color = 'rgba(117, 141, 163, 0.6)';
      } else {
        incQuantityElement.style.color = 'var(--heading-color)';
      }
    });
  });
};

const calcShipping = function(variant, quantity) {
  var shippingDivs = document.querySelectorAll('.icon-text-row.shipping');
  if (shippingDivs.length === 0) {
    return;
  }

  shippingDivs.forEach(function(shippingDiv) {
    var shippingSpan = shippingDiv.querySelector('span');
    if (!shippingSpan) {
      return;
    }
    var quantityInput = shippingDiv.closest("form.product-form").querySelector("input.quantity-selector__value")
    if (!quantityInput) {
      return;
    }

    var quantity = Number(quantityInput.value);
    var now = new Date();
    var currentDay = now.getDay(); // 0 is Sunday, 1 is Monday, ..., 6 is Saturday
    var currentHour = now.getHours();
    var variantPrice = variant.price / 100 * quantity; // Asumiendo que el precio de la variante viene en centavos
    var shippingText = 'Llega ';
    var shippingCost;

    if (variant.available) {
      // Establecer el costo de envío basado en el precio de la variante
      if (variantPrice >= 30000) {
        shippingText += 'gratis ';
      } else {
        shippingCost = '$1500';
      }

      // Cambiar el texto de envío basado en la hora del día y el día de la semana
      if (currentDay >= 1 && currentDay <= 5) { // Lunes a Viernes
        if (currentHour < 14) {
          shippingText += shippingCost ? '<strong>hoy</strong> (envío ' + shippingCost + ')' : '<strong>hoy</strong>';
        } else {
          shippingText += shippingCost ? '<strong>mañana</strong> (envío ' + shippingCost + ')' : '<strong>mañana</strong>';
        }
      } else if (currentDay == 6) { // Sábado
        if (currentHour < 7) {
          shippingText += shippingCost ? '<strong>hoy</strong> (envío ' + shippingCost + ')' : '<strong>hoy</strong>';
        } else {
          shippingText += shippingCost ? '<strong>el lunes</strong> (envío ' + shippingCost + ')' : '<strong>el lunes</strong>';
        }
      } else { // Domingo
        shippingText += shippingCost ? '<strong>el lunes</strong> (envío ' + shippingCost + ')' : '<strong>el lunes</strong>';
      }
      shippingDiv.classList.remove('shipping-not-available');
    } else {
      shippingText = 'Agotado';
      shippingDiv.classList.add('shipping-not-available');
    }

    // Actualizar el texto del envío en la página
    shippingSpan.innerHTML = shippingText;
  });
};

document.addEventListener('quantity:changed', function(event) {
  if (!window.location.pathname.startsWith("/products")) {
    return;
  }

  const {
    newQuantity
  } = event.detail;

  // document.querySelectorAll("[data-action='decrease-picker-quantity']").forEach(function(el) {
  //   if(newQuantity == 1) {
  //     el.style.color = 'rgba(117, 141, 163, 0.6)';
  //   }
  //   else {
  //     el.style.color = 'var(--heading-color)';
  //   }
  // });

  document.querySelectorAll(".quantity-selector__value").forEach(function(el) {
    el.value = newQuantity;
  });

  const variantId = Number(document.querySelector("form.product-form select[name='id']").value);
  const selectedVariant = JSON.parse(document.querySelector('[data-product-json]').innerHTML).product.variants.find(v => v.id === variantId);

  refreshQuantityButtons();
  calcShipping(selectedVariant, newQuantity);
});

document.addEventListener('variant:changed', function(event) {
  const variant = event.detail && event.detail.variant;
  if (!variant) return;

  const formEl = event.target.closest && event.target.closest('form.product-form');
  const scopeEl = formEl || event.target;

  scopeEl.querySelectorAll('.product-form__add-button').forEach(function(buttonEl, index) {
    if (variant.available) {
      buttonEl.removeAttribute('disabled');
      buttonEl.classList.remove('button--disabled');
      buttonEl.classList.add('button--primary');
      buttonEl.setAttribute('data-action', 'add-to-cart');
      const onProductPage = window.location.pathname.startsWith('/products');
      const hasProductJson = !!document.querySelector('form script[data-product-json]');
      buttonEl.innerHTML = (!onProductPage && index == 0) || (onProductPage && index === 0 && hasProductJson) ? 'Agregar al carrito' : 'Agregar';
    } else {
      buttonEl.setAttribute('disabled', 'disabled');
      buttonEl.classList.add('button--disabled');
      buttonEl.classList.remove('button--primary');
      buttonEl.removeAttribute('data-action');
      buttonEl.innerHTML = 'Agotado';
    }
  });

});

function getVariantFeaturedImageUrl(variant) {
  if (!variant) return null;
  if (variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
  if (typeof variant.featured_image === 'string') return variant.featured_image;
  if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
    return variant.featured_media.preview_image.src;
  }
  return null;
}

function getVariantFeaturedMediaId(variant) {
  if (!variant) return null;
  if (variant.featured_image && variant.featured_image.id) return String(variant.featured_image.id);
  if (variant.featured_media && variant.featured_media.id) return String(variant.featured_media.id);
  if (variant.image_id) return String(variant.image_id);
  return null;
}

function buildResponsiveSrc(src, width) {
  if (!src || !width) return src;
  try {
    const url = new URL(src, window.location.origin);
    const dotIdx = url.pathname.lastIndexOf('.');
    if (dotIdx === -1) return src;
    const base = url.pathname.substring(0, dotIdx);
    const ext = url.pathname.substring(dotIdx);
    if (/_(\d+x|\d+x\d+|x\d+)$/.test(base)) {
      url.pathname = base.replace(/_(\d+x|\d+x\d+|x\d+)$/, '') + '_' + width + 'x' + ext;
    } else {
      url.pathname = base + '_' + width + 'x' + ext;
    }
    return url.toString();
  } catch (e) {
    return src;
  }
}

function buildSrcset(src, widths) {
  return widths.map(function(w) { return buildResponsiveSrc(src, w) + ' ' + w + 'w'; }).join(', ');
}

function getVariantFeaturedAspectRatio(variant) {
  if (!variant) return null;
  const img = variant.featured_image;
  if (img && typeof img === 'object') {
    if (img.aspect_ratio) return img.aspect_ratio;
    if (img.width && img.height) return img.width / img.height;
  }
  const media = variant.featured_media;
  if (media) {
    if (media.aspect_ratio) return media.aspect_ratio;
    if (media.preview_image && media.preview_image.aspect_ratio) return media.preview_image.aspect_ratio;
    if (media.preview_image && media.preview_image.width && media.preview_image.height) {
      return media.preview_image.width / media.preview_image.height;
    }
  }
  return null;
}

function updateProductItemImage(productItem, variant) {
  if (!productItem || !variant) return;
  const imgEl = productItem.querySelector('.product-item__primary-image');
  if (!imgEl) return;

  const newMediaId = getVariantFeaturedMediaId(variant);
  const newSrc = getVariantFeaturedImageUrl(variant);
  if (!newSrc || !newMediaId) return;
  if (imgEl.getAttribute('data-media-id') === newMediaId) return;

  imgEl.setAttribute('data-media-id', newMediaId);
  imgEl.setAttribute('src', buildResponsiveSrc(newSrc, 600));
  imgEl.setAttribute('srcset', buildSrcset(newSrc, [200, 300, 400, 600, 800, 1000, 1200, 1400, 1600]));

  const aspectRatio = getVariantFeaturedAspectRatio(variant);
  const aspectContainer = imgEl.closest('.aspect-ratio');
  if (aspectRatio && aspectContainer && !aspectContainer.classList.contains('aspect-ratio--square') && !aspectContainer.classList.contains('aspect-ratio--portrait') && !aspectContainer.classList.contains('aspect-ratio--landscape')) {
    aspectContainer.style.paddingBottom = (100.0 / aspectRatio) + '%';
  }

  const titleLink = productItem.querySelector('a.product-item__title');
  const variantUrl = titleLink ? titleLink.getAttribute('href') : '';
  if (variantUrl) {
    const baseUrl = variantUrl.split('?')[0];
    const newUrl = baseUrl + '?variant=' + variant.id;
    productItem.querySelectorAll('.product-item__image-wrapper, .product-item__title').forEach(function(a) {
      a.setAttribute('href', newUrl);
    });
  }
}

function formatMoneyLikeShopify(cents, format) {
  if (cents == null || isNaN(cents)) return '';
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || '${{amount}}';
  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (precision == null) precision = 2;
    if (thousands == null) thousands = ',';
    if (decimal == null) decimal = '.';
    if (isNaN(number) || number == null) return '0';
    number = (number / 100.0).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    const centsPart = parts[1] ? decimal + parts[1] : '';
    return dollars + centsPart;
  }
  const match = formatString.match(placeholderRegex);
  if (!match) return formatString;
  let value = '';
  switch (match[1]) {
    case 'amount': value = formatWithDelimiters(cents, 2); break;
    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
    case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', '.'); break;
    case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
    case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
    case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
    case 'amount_no_decimals_with_apostrophe_separator': value = formatWithDelimiters(cents, 0, "'"); break;
    default: value = formatWithDelimiters(cents, 2);
  }
  return formatString.replace(placeholderRegex, value);
}

function formatMoneyWithoutTrailingZeros(cents) {
  const format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
  let out = formatMoneyLikeShopify(cents, format);
  // mimic Liquid `money_without_trailing_zeros`: strip ",00" or ".00" decimals
  out = out.replace(/([,.])00(\D|$)/, '$2');
  return out;
}

function updateProductItemPrice(productItem, variant) {
  if (!productItem || !variant) return;
  const priceList = productItem.querySelector('.product-item__price-list, .price-list');
  if (!priceList) return;

  const compare = variant.compare_at_price && variant.compare_at_price > variant.price;
  // DOM order matches Liquid templates: compare first, highlight second.
  // Visual order is reversed by .price-list { flex-direction: row-reverse } in theme.css.
  const priceHtml = compare
    ? '<span class="price price--compare">' + formatMoneyWithoutTrailingZeros(variant.compare_at_price) + '</span>' +
      '<span class="price price--highlight">' + formatMoneyWithoutTrailingZeros(variant.price) + '</span>'
    : '<span class="price">' + formatMoneyWithoutTrailingZeros(variant.price) + '</span>';

  if (priceList.classList.contains('price-list')) {
    priceList.innerHTML = priceHtml;
  } else {
    const inner = priceList.querySelector('.price-list');
    if (inner) inner.innerHTML = priceHtml;
  }
}

function getProductDataFromItem(productItem) {
  // The product-item snippet places <script data-product-json> as a SIBLING of the .product-item div
  // (closing </div> at line 362 then <script> at line 364 in product-item.liquid).
  // Search the closest section/wrapper ancestor that contains both.
  let jsonEl = productItem.querySelector('script[data-product-json]');
  if (!jsonEl) {
    const wrapper = productItem.closest('[data-section-type="product"]')
      || productItem.parentElement;
    if (wrapper) jsonEl = wrapper.querySelector('script[data-product-json]');
  }
  if (!jsonEl) return null;
  try {
    const data = JSON.parse(jsonEl.innerHTML);
    return data.product || data;
  } catch (e) {
    return null;
  }
}

function findVariantBySelectedOptions(productItem) {
  const product = getProductDataFromItem(productItem);
  if (!product || !product.variants) return null;

  const selected = [];
  productItem.querySelectorAll('.product-form__single-selector').forEach(function(sel) {
    let value;
    if (sel.tagName === 'SELECT') {
      value = sel.value;
    } else if (sel.type === 'radio') {
      if (!sel.checked) return;
      value = sel.value;
    } else {
      value = sel.value;
    }
    const position = parseInt(sel.getAttribute('data-option-position'), 10);
    if (position) selected[position - 1] = value;
  });

  if (selected.length === 0) return null;

  return product.variants.find(function(v) {
    return (selected[0] === undefined || v.option1 === selected[0]) &&
           (selected[1] === undefined || v.option2 === selected[1]) &&
           (selected[2] === undefined || v.option3 === selected[2]);
  }) || null;
}

// Wherever a product gallery + variant form coexist (product page, quick-view modal, featured-product section),
// clicking a thumbnail also switches the variant whose featured_media matches.
document.addEventListener('click', function(event) {
  const thumb = event.target.closest && event.target.closest('.product-gallery__thumbnail');
  if (!thumb) return;
  const mediaId = thumb.getAttribute('data-media-id');
  if (!mediaId) return;

  const section = thumb.closest('[data-section-type="product"]') || thumb.closest('section, .product-form, .featured-product, .product-item');
  if (!section) return;
  const jsonEl = section.querySelector('script[data-product-json]');
  if (!jsonEl) return;
  let data;
  try { data = JSON.parse(jsonEl.innerHTML); } catch (e) { return; }
  const product = (data && data.product) || data;
  if (!product || !product.variants) return;

  const variant = product.variants.find(function(v) {
    if (v.featured_image && String(v.featured_image.id) === String(mediaId)) return true;
    if (v.featured_media && String(v.featured_media.id) === String(mediaId)) return true;
    if (v.image_id != null && String(v.image_id) === String(mediaId)) return true;
    return false;
  });
  if (!variant) return;

  const form = section.querySelector('form.product-form');
  if (!form) return;

  ['option1', 'option2', 'option3'].forEach(function(optKey, idx) {
    const optValue = variant[optKey];
    if (optValue == null) return;
    const position = idx + 1;
    const selectors = form.querySelectorAll('.product-form__single-selector[data-option-position="' + position + '"]');
    if (selectors.length === 0) return;

    let dispatchTarget = null;
    selectors.forEach(function(sel) {
      if (sel.tagName === 'SELECT') {
        if (sel.value !== optValue) {
          sel.value = optValue;
          dispatchTarget = sel;
        } else if (!dispatchTarget) {
          dispatchTarget = sel;
        }
      } else if (sel.type === 'radio') {
        const shouldBeChecked = sel.value === optValue;
        if (shouldBeChecked && !sel.checked) {
          sel.checked = true;
          dispatchTarget = sel;
        } else if (shouldBeChecked && !dispatchTarget) {
          dispatchTarget = sel;
        }
      }
    });

    if (dispatchTarget) {
      dispatchTarget.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
});

document.addEventListener('change', function(event) {
  const selector = event.target.closest && event.target.closest('.product-form__single-selector');
  if (!selector) return;
  const productItem = selector.closest('.product-item');
  if (!productItem) return;

  const variant = findVariantBySelectedOptions(productItem);
  if (!variant) return;

  const formEl = selector.closest('form.product-form, form.product-item__action-list');
  if (formEl) {
    const hiddenId = formEl.querySelector("input[name='id']") || formEl.querySelector("select[name='id']");
    if (hiddenId) hiddenId.value = variant.id;
  }

  updateProductItemImage(productItem, variant);
  updateProductItemPrice(productItem, variant);

  if (formEl) {
    formEl.dispatchEvent(new CustomEvent('variant:changed', {
      bubbles: true,
      detail: { variant: variant }
    }));
  }
});


document.addEventListener('variant:changed', function(event) {
  if (!window.location.pathname.startsWith("/products")) {
    return;
  }

  document.querySelectorAll('.quantity-selector__value').forEach(function(quantityEl) {
    quantityEl.value = 1;
  });

  setTimeout(() => {
    const variantId = Number(document.querySelector("form.product-form select[name='id']").value);
    const selectedVariant = JSON.parse(document.querySelector('[data-product-json]').innerHTML).product.variants.find(v => v.id === variantId);
    const quantity = Number(document.querySelector("form.product-form input[name='quantity']").value);

    const el = document.querySelector(".grid > div:last-child [name='id']");

    if (el) {
      el.value = variantId;
    }

    refreshQuantityButtons();

    calcShipping(selectedVariant, quantity);
  }, 0);
});

document.addEventListener('variant:changed', function(event) {
  if (window.location.pathname.startsWith("/products")) {
    return;
  }

  const inputEl = event.target.querySelector("form input[name='id']");

  if (!inputEl) {
    return;
  }

  inputEl.value = event.detail.variant.id;
});

document.addEventListener("DOMContentLoaded", function() {
  if (window.location.pathname.startsWith("/products")) {
    refreshQuantityButtons();
  }

  const stateSelect = document.getElementById('state-selector');
  const stateSelectMobile = document.getElementById('state-selector-mobile');
  const urlState = window.location.host.replace("www.", "").split(".")[0];
  const cookieState = document.cookie.split(';').map(c => c.trim().split('=')).find(c => c[0] === 'state')?.[1];
  const selectedState = ["ba", "mendoza", "cordoba", "rosario"].includes(urlState) ? urlState : cookieState;

  stateSelect.value = selectedState;
  stateSelectMobile.value = selectedState;
  document.cookie = "state=" + selectedState + ";domain=.pluspet.com.ar;path=/";
  stateSelect.addEventListener('change', function(v) {
    const subdomain = v.target.value;
    window.location.href = `https://${subdomain}.pluspet.com.ar`;
  });
  stateSelectMobile.addEventListener('change', function(v) {
    const subdomain = v.target.value;
    window.location.href = `https://${subdomain}.pluspet.com.ar`;
  });

  document.querySelectorAll('.titulo').forEach(el => {
    el.addEventListener('click', () => {
      document.querySelectorAll('.titulo').forEach(el2 => {
        if (el === el2) {
          const divContent = el.nextElementSibling;
          const icon = el.querySelector("span");

          if (!divContent.style.display || divContent.style.display === "none") {
            divContent.style.display = "block";
            icon.textContent = "-";
          } else {
            divContent.style.display = "none";
            icon.textContent = "+";
          }
        } else {
          el2.nextElementSibling.style.display = "none";
          el2.querySelector("span").textContent = "+";
        }
      });

    });
  });

  const buttons = document.getElementsByClassName('collection__layout-button');
  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener('click', () => window.dispatchEvent(new Event('resize')));
  }

  const toggleSearchElement = document.querySelector("a[data-action='toggle-search']");
  if (!toggleSearchElement || window.location.pathname.startsWith("/products")) {
    return;
  }

  toggleSearchElement.click();
});

var isScrolling;

function isElementVisible(el, checkBottom = false) {
  var rect = el.getBoundingClientRect();
  var windowHeight = (window.innerHeight || document.documentElement.clientHeight);

  // Comprobando si la parte superior del elemento está dentro o por encima del viewport
  
  return checkBottom ? ((rect.bottom + 48) <= windowHeight) : (rect.top <= windowHeight);
}

function debounce(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this,
      args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

const handleScroll = function() {
  var ws = document.querySelector('#chwhatsapp-btn');
  var buyBar = document.querySelector('#buy-bar');
  var recentlyViewed = document.querySelector('.recently-viewed-products-placeholder');
  var paymentMethods = buyBar ? buyBar.previousElementSibling : null;

  if (paymentMethods) {
    if (isElementVisible(paymentMethods, true)) {
      if (buyBar) {
        buyBar.classList.remove('fixed-bottom');
        // buyBar.classList.remove('hidden');
        if (ws) {
          ws.parentElement.style.setProperty('bottom', '16px', 'important');
        }
      }
    } else {
      if (buyBar) {
        buyBar.classList.add('fixed-bottom');
        // buyBar.classList.add('hidden');
        if (ws) {
          ws.parentElement.style.setProperty('bottom', '85px', 'important');
        }
      }
    }
  }

  if (recentlyViewed) {
    if (isElementVisible(recentlyViewed)) {
      if (ws) {
        ws.style.display = 'block';
      }
    } else {
      if (ws) {
        ws.style.display = 'none';
      }
    }
  }

  // if (buyBar && buyBar.classList.contains("fixed-bottom")) {
  //     buyBar.classList.add('hidden');
  // }

  if (ws) {
    ws.classList.add('hidden');
  }

  window.clearTimeout(isScrolling);

  isScrolling = setTimeout(function() {
    if (paymentMethods) {
      if (isElementVisible(paymentMethods, true)) {
        if (buyBar) {
          buyBar.classList.remove('fixed-bottom');
          // buyBar.classList.remove('hidden');
          if (ws) {
            ws.parentElement.style.setProperty('bottom', '16px', 'important');
          }
        }
      } else {
        if (buyBar) {
          buyBar.classList.add('fixed-bottom');
          // buyBar.classList.add('hidden');
          if (ws) {
            ws.parentElement.style.setProperty('bottom', '85px', 'important');
          }
        }
      }
    }

    if (recentlyViewed) {
      if (isElementVisible(recentlyViewed)) {
        if (ws) {
          ws.style.display = 'block';
        }
      } else {
        if (ws) {
          ws.style.display = 'none';
        }
      }
    }

    // if (buyBar) {
    //     buyBar.classList.remove('hidden');
    // }

    if (ws) {
      ws.classList.remove('hidden');
    }
  }, 500);
}

window.addEventListener('scroll', handleScroll);

window.addEventListener('touchmove', scrollHandler);
window.addEventListener('touchend', scrollEndHandler);

function scrollHandler() {
  var ws = document.querySelector('#chwhatsapp-btn');
  var buyBar = document.querySelector('#buy-bar');
  var recentlyViewed = document.querySelector('.recently-viewed-products-placeholder');
  var paymentMethods = buyBar ? buyBar.previousElementSibling : null;

  if (paymentMethods) {
    if (isElementVisible(paymentMethods, true)) {
      if (buyBar) {
        buyBar.classList.remove('fixed-bottom');
        // buyBar.classList.remove('hidden');
        if (ws) {
          ws.parentElement.style.setProperty('bottom', '16px', 'important');
        }
      }
    } else {
      if (buyBar) {
        buyBar.classList.add('fixed-bottom');
        // buyBar.classList.add('hidden');
        if (ws) {
          ws.parentElement.style.setProperty('bottom', '85px', 'important');
        }
      }
    }
  }

  if (recentlyViewed) {
    if (isElementVisible(recentlyViewed)) {
      if (ws) {
        ws.style.display = 'block';
      }
    } else {
      if (ws) {
        ws.style.display = 'none';
      }
    }
  }

  // if (buyBar && buyBar.classList.contains("fixed-bottom")) {
  //     buyBar.classList.add('hidden');
  // }

  if (ws) {
    ws.classList.add('hidden');
  }

  window.clearTimeout(isScrolling);
}

function scrollEndHandler() {
  var ws = document.querySelector('#chwhatsapp-btn');
  var buyBar = document.querySelector('#buy-bar');
  var recentlyViewed = document.querySelector('.recently-viewed-products-placeholder');
  var paymentMethods = buyBar ? buyBar.previousElementSibling : null;

  isScrolling = setTimeout(function() {
    if (paymentMethods) {
      if (isElementVisible(paymentMethods, true)) {
        if (buyBar) {
          buyBar.classList.remove('fixed-bottom');
          // buyBar.classList.remove('hidden');
          if (ws) {
            ws.parentElement.style.setProperty('bottom', '16px', 'important');
          }
        }
      } else {
        if (buyBar) {
          buyBar.classList.add('fixed-bottom');
          // buyBar.classList.add('hidden');
          if (ws) {
            ws.parentElement.style.setProperty('bottom', '85px', 'important');
          }
        }
      }
    }

    if (recentlyViewed) {
      if (isElementVisible(recentlyViewed)) {
        if (ws) {
          ws.style.display = 'block';
        }
      } else {
        if (ws) {
          ws.style.display = 'none';
        }
      }
    }

    // if (buyBar) {
    //     buyBar.classList.remove('hidden');
    // }

    if (ws) {
      ws.classList.remove('hidden');
    }
  }, 500);
}